import React from 'react'

export function Center({children}: React.PropsWithChildren<{}>) {

  return (
    <div style={{position: 'absolute',
                top: 110,
                left: 0,
                bottom: 0,
                right: 0,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 1}}>
      { children }
    </div>
  )
}